export const locale = {
    lang: 'pl',
    data: {
        'Too much opened tabs/windows with application. You should have opened only one tab or window.': 'Zbyt dużo otwartych zakładek/okien z aplikacją. Powiniennaś otworzyć tylko jedną zakładkę lub okno.',
    }
};
